import type { TrafficWidgetState } from "./TrafficWidgets/types";

export const getTrafficWidgetState = ({
    isLoading,
    isLocked,
    isEmpty,
}: {
    isLoading: boolean;
    isLocked: boolean;
    isEmpty: boolean;
}): TrafficWidgetState => {
    if (isLoading) {
        return "loading";
    }
    if (isLocked) {
        return "locked";
    }
    if (isEmpty) {
        return "empty";
    }

    return "default";
};
